import React from "react"
import "./component.css"

export class TiggbeePartnerContent extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isLargeScreen: false
        }
    }

    componentDidMount = () => {
        this.mediaQuery = window.matchMedia("(min-width: 992px)");
        this.setState({
            isLargeScreen: this.mediaQuery.matches
        });
        this.mediaQuery.addEventListener("change", this.handleChange);
    }

    componentWillUnmount = () => {
        if (this.mediaQuery) {
            this.mediaQuery.removeEventListener("change", this.handleChange);
        }
    }

    handleChange = (e) => {
        this.setState({
            isLargeScreen: e.matches
        });
    };

    renderOurPartnersPart = () => {
        const partners = [
            { id: 'amazon', row: 1, ratio: '18%' },
            { id: 'chick-fil-a', row: 1, ratio: '18%' },
            { id: 'semi-foundation', row: 1, ratio: '18%' },
            { id: 'panasonic', row: 1, ratio: '18%' },
            { id: 'fm-industries', row: 1, ratio: '28%' },
            { id: 'calumet-electronics', row: 1, ratio: '20%' },
            { id: 'hsc-labs', row: 2, ratio: '11%' },
            { id: 'uber', row: 2, ratio: '11%' },
            { id: 'delta-dental', row: 2, ratio: '19%' },
            { id: 'health-university-of-utah', row: 2, ratio: '15%' },
            { id: 'entegris', row: 2, ratio: '17%' },
            { id: 'edwards', row: 2, ratio: '17%' },
            { id: 'united-states-coast-guard', row: 2, ratio: '10%', size: { width: 'auto', height: '90px' } }
        ];
        const element = (
            <>
                <div className="content-section-container" style={{ paddingTop: "30px", paddingBottom: "30px" }}>
                    <div className="line-title">
                        <div className="text">Some of our <b>PARTNERS INCLUDE</b></div>
                        <div className="line" />
                    </div>
                    <div className="table-container white-table" style={{ paddingTop: "36px", paddingBottom: "36px", margin: "0px" }}>
                        {
                            this.state.isLargeScreen ?
                                <>
                                    <div className="grid-layout-container" style={{ gap: '45px' }}>
                                        {partners.filter(partner => partner.row === 1).map(partner => (
                                            <div className="logo-container" style={{ width: partner.ratio }}>
                                                <img alt="" src={`/${partner.id}-logo.png`} style={{ width: '100%', height: 'auto' }} />
                                            </div>
                                        ))}
                                    </div>
                                    <div className="grid-layout-container" style={{ gap: '45px' }}>
                                        {partners.filter(partner => partner.row === 2).map(partner => (
                                            <div className="logo-container" style={{ width: partner.ratio }}>
                                                <img alt="" src={`/${partner.id}-logo.png`} style={{ width: '100%', height: 'auto' }} />
                                            </div>
                                        ))}
                                    </div>
                                </> :
                                <div className="row">
                                    {
                                        partners.map(partner => (
                                            <div className='col-6 col-md-3 col-lg-2 logo-container'>
                                                <img alt="" src={`/${partner.id}-logo.png`} style={{ width: partner?.size?.width ?? '100%', height: partner?.size?.height ?? 'auto' }} />
                                            </div>
                                        ))
                                    }
                                </div>
                        }
                    </div>
                    <div className="line-title">
                        <div className="line" />
                    </div>
                </div>
            </>
        );
        return element;
    }

    render() {
        const html = (
            <>
                {this.renderOurPartnersPart()}
            </>
        )
        return html
    }
}